import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c6e715ac"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mooc-course"
};
const _hoisted_2 = ["href"];
const _hoisted_3 = {
  class: "course-list"
};
const _hoisted_4 = {
  key: 0,
  class: "no-data"
};
import SectionContainer from './SectionContainer.vue';
import CourseCard from './CourseCard.vue';
import { Empty } from 'zhs-components';
export default /*#__PURE__*/_defineComponent({
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    }
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const homeCourseList = ref([]);
    const authType = ref(0);

    const getHomeCourseList = async () => {
      const homeCourse = await $http.getHomeMooc({
        num: props.menu.num,
        menu_id: props.menu.menu_id,
        classify_id: ''
      }); // homeCourseList.value = [...homeCourse, ...homeCourse]

      homeCourseList.value = homeCourse;
    };

    const getAuth = async () => {
      const res2 = await $http.getConfigList();
      authType.value = res2.find(item => item.code == '10401') ? res2.find(item => item.code == '10401').auth_type : 0;
    };

    onMounted(() => {
      getAuth();
      getHomeCourseList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SectionContainer, {
        title: __props.menu.module_name,
        bg: `linear-gradient(180deg, var(--el-color-primary) 0%, var(--el-color-primary-light-8) 100%)`,
        isWhiteTheme: ""
      }, {
        action: _withCtx(() => [_createElementVNode("a", {
          href: `/courseList.html?type=1&name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
        }, " 全部 > ", 8, _hoisted_2)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [homeCourseList.value && homeCourseList.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(homeCourseList.value.slice(0, 5), course => {
          return _openBlock(), _createBlock(CourseCard, {
            class: "course-card",
            "is-opacity": "",
            "course-data": course,
            key: course.id,
            "show-label": true,
            userInfo: __props.userInfo,
            authType: authType.value
          }, null, 8, ["course-data", "userInfo", "authType"]);
        }), 128)) : _createCommentVNode("", true)]), homeCourseList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(Empty))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["title", "bg"])]);
    };
  }

});